import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
/**
 * Url helper for data grid/list filters
 */

import { Utils } from 'ecrion-components';
import DEFAULT_VALUE from './defaultFilter';
/**
 * Example: `label-f=Custom&stageId-f=369&threadName-s=liv`
 *
 * @param {typeof DEFAULT_VALUE} filter
 */

var serialize = function serialize(filter) {
  if (!filter) return '';
  var output = '';
  if (filter.label && filter.label !== DEFAULT_VALUE.label) output += 'label-f=' + encodeURIComponent(filter.label);

  if (filter.filterBy && filter.filterValue) {
    if (output) output += '&';
    output += encodeURIComponent(filter.filterBy) + '-f=' + encodeURIComponent(filter.filterValue);
  }

  if (filter.searchIn && filter.searchValue) {
    if (output) output += '&';
    output += encodeURIComponent(filter.searchIn) + '-s=' + encodeURIComponent(filter.searchValue);
  }

  return output;
};
/**
 * Example: `?label-f=Custom&stageId-f=369&threadName-s=liv&any-other-param-not-affected=value`
 *
 * @param {string} filterStr Serialized filter (can be location.search)
 * @param {import('./types').DataFilterValueType} [baseValue] Base value for the filter
 * @returns {import('./types').DataFilterValueType}
 */


var deserialize = function deserialize(filterStr) {
  var baseValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (typeof filterStr !== 'string') return baseValue;
  if (!filterStr) return baseValue;
  var queryParams = Utils.url.getSearchParams(filterStr);

  var filter = _objectSpread({}, DEFAULT_VALUE, baseValue);

  Object.keys(queryParams).map(function (paramName) {
    if (paramName === 'label-f') {
      filter.label = queryParams[paramName];
      return;
    }

    if (paramName.endsWith('-f')) {
      filter.filterBy = paramName.substring(0, paramName.length - 2);
      filter.filterValue = queryParams[paramName];
      if (!isNaN(filter.filterValue)) filter.filterValue = parseInt(filter.filterValue);
      return;
    }

    if (paramName.endsWith('-s')) {
      filter.searchIn = paramName.substring(0, paramName.length - 2);
      filter.searchValue = queryParams[paramName];
      return;
    }
  });
  return filter;
};

var getNewLocation = function getNewLocation(location, q) {
  var searchParams = Utils.url.getSearchParams(location);
  if (!searchParams && !q) return location.pathname; //remove filter params

  Object.keys(searchParams).map(function (searchParamName) {
    if (searchParamName.endsWith('-f')) delete searchParams[searchParamName];
    if (searchParamName.endsWith('-s')) delete searchParams[searchParamName];
  });
  var search = Utils.url.stringifySearchParams(_objectSpread({}, searchParams, Utils.url.getSearchParams(q)));
  return location.pathname + '?' + search;
};

var createFromLocation = function createFromLocation(location) {
  var baseValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_VALUE;
  return deserialize(location.search, baseValue);
};

export default {
  serialize: serialize,
  deserialize: deserialize,
  getNewLocation: getNewLocation,
  createFromLocation: createFromLocation
};